import { render, staticRenderFns } from "./roleCom.vue?vue&type=template&id=6706f8f1&scoped=true&"
import script from "./roleCom.vue?vue&type=script&lang=js&"
export * from "./roleCom.vue?vue&type=script&lang=js&"
import style0 from "./roleCom.vue?vue&type=style&index=0&id=6706f8f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6706f8f1",
  null
  
)

export default component.exports